import { render } from "./phone_step.vue?vue&type=template&id=4ea80c8b"
import script from "./phone_step.vue?vue&type=script&lang=js"
export * from "./phone_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/phone_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ea80c8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ea80c8b', __exports__)) {
    api.reload('4ea80c8b', __exports__)
  }
  
  module.hot.accept("./phone_step.vue?vue&type=template&id=4ea80c8b", () => {
    api.rerender('4ea80c8b', render)
  })

}


export default __exports__